import { r as registerInstance, h, g as getElement, c as createEvent, H as Host } from './index-5faac9d7.js';
import './index-e29b327a.js';
import { P as PesRoute } from './pes-route-5a1043d8.js';
import { i as isAppRoutingEnabled, n as navigateWithRouter } from './utils-e0387569.js';
import { d as getCtaInfoMapping, g as getLocaleCodes } from './helpers-c4d5ad02.js';
import { C as CheckoutEventEmitter } from './checkoutEventEmitter.service-41cc6ce1.js';
import { p as parseCommonURLToRouterParts } from './url-parser-bc0c129e.js';
import { m as myProductsResponseStatus } from './currency-7be6806c.js';
import { b as buildCTAClickEvent, s as sendAnalytics, a as NO_LETTERS_AND_LEADING_ZERO_REGEXP, g as getMinValue, d as RUNTIME_FIELD_MAX_LENGTH, f as formatMessage, v as validate, e as calculateRuntime, h as stringifyRuntime, R as RUNTIME_ERROR_CODES_TO_LABELS } from './utils-d4e93fbe.js';
import { i as isAnalyticsEnabled } from './helpers-e12aa36b.js';
import './lodash-bd96d09c.js';
import './_commonjsHelpers-11ca3be1.js';
import './analytics-205f1857.js';
import './_nodeUtil-f95b2b52.js';
import './_Stack-68736bd1.js';
import './pes-router-store-0c1092be.js';
import './index-54dd34b7.js';
import './tslib.es6-613ce1cd.js';
import './__node-resolve_empty-7dfe5913.js';
import './_isIndex-3036d479.js';
import './toNumber-6e3a0b09.js';
import './isSymbol-bae590b5.js';
import './index-e233ecdd.js';
import './isEmpty-51908328.js';
import './toString-10b0f228.js';
import './_basePickBy-e4f30088.js';
import './_arrayLikeKeys-728b0edd.js';
import './keysIn-6ff99c07.js';
import './hasIn-53d8ae96.js';
import './_flatRest-cb1a737b.js';
import './_baseFlatten-65704796.js';
import './omitBy-313ebee0.js';
import './_baseIteratee-285d44d0.js';
import './_getAllKeys-407edbf9.js';
import './_getAllKeysIn-c79cfca8.js';
import './utils-ba4359e5.js';
import './flatMap-f62e8c63.js';
import './_baseFor-a28737de.js';
import './analytics-b6a65ffa.js';
import './number-57a50dcb.js';

const pesAlternativeCss = ":host{display:block}.alternative__control{font-size:rem-calc(12);flex:0 0 auto}@media screen and (max-width: 979px){.alternative__control{order:3;box-sizing:border-box;margin:15px -15px 0;padding:10px 15px;min-height:60px;display:flex;justify-content:center;align-items:center;border-top:1px solid #e7e6e6}}@media screen and (min-width: 980px){.alternative__control{line-height:rem-calc(16)}:host(:not([dir=\"rtl\"])) .alternative__control{margin:0 0 0 auto}:host([dir=\"rtl\"]) .alternative__control{margin:0 auto 0 0}}.alternative__content{display:flex;flex:0 0 100%;padding:0 15px}@media screen and (min-width: 980px){.alternative__content{flex-wrap:wrap;align-items:start;flex-direction:row}}@media screen and (max-width: 979px){.alternative__content{flex-direction:column}}.alternative-item{display:flex;text-decoration:none;flex:0 0 100%}@media screen and (max-width: 979px){.alternative-item{position:relative}}.alternative-item__image{width:50px;height:50px}@media screen and (min-width: 980px){:host(:not([dir=\"rtl\"])) .alternative-item__image:not(:first-child){margin-left:5px}:host([dir=\"rtl\"]) .alternative-item__image:not(:first-child){margin-right:5px}}:host(:not([dir=\"rtl\"])) .alternative-item__body{margin-left:15px}:host([dir=\"rtl\"]) .alternative-item__body{margin-right:15px}.alternative-item__description{font-size:rem-calc(14);line-height:rem-calc(20);color:#333333;margin:0}@media screen and (min-width: 980px){.alternative-item:active .alternative-item__description,.alternative-item:hover .alternative-item__description{text-decoration:underline}}.alternative-item__comment{margin:0 0 20px;color:#626469;font-size:rem-calc(12)}@media screen and (max-width: 979px){.alternative-item__comment{line-height:rem-calc(15)}}@media screen and (min-width: 980px){.alternative-item__comment{flex:1 1 80%}}.alternative-item__name{font-size:rem-calc(10);line-height:rem-calc(20);color:#626469}";

const PesAlternative = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.linkClickHandler = (event) => {
      if (!isAppRoutingEnabled())
        return;
      event.preventDefault();
      navigateWithRouter(this.route, event.currentTarget);
    };
    this.handleUcEvent = (cta) => (_) => {
      CheckoutEventEmitter.dispatchCheckoutEvent(cta, this.checkoutEasyPayload);
    };
    this.addToCartLabel = undefined;
    this.header = undefined;
    this.imageURL = undefined;
    this.imageTitle = undefined;
    this.description = undefined;
    this.comment = undefined;
    this.url = undefined;
    this.itemCtas = undefined;
    this.ctaInfo = undefined;
    this.localeCode = undefined;
    this.productUrl = undefined;
    this.ctaInfoMapping = {};
    this.checkoutEasyPayload = null;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  componentWillLoad() {
    var _a;
    this.productUrl = this.url;
    this.ctaInfoMapping = getCtaInfoMapping(this.itemCtas, this.ctaInfo);
    const getLocaleData = getLocaleCodes(this.localeCode);
    const country = (_a = getLocaleData === null || getLocaleData === void 0 ? void 0 : getLocaleData.countryCode) === null || _a === void 0 ? void 0 : _a.toUpperCase();
    const locale = `${getLocaleData === null || getLocaleData === void 0 ? void 0 : getLocaleData.languageCode}_${country}`;
    this.checkoutEasyPayload = {
      country,
      locale,
      productId: this.header,
    };
    if (!isAppRoutingEnabled())
      return;
    const { pageType, pageId } = parseCommonURLToRouterParts(this.productUrl);
    this.route = new PesRoute({ page: pageType, pageId });
    this.productUrl = this.route.url;
  }
  render() {
    var _a, _b;
    return (h("div", { class: "alternative__content" }, this.comment && h("p", { class: "alternative-item__comment" }, this.comment), h("div", { class: "alternative__control" }, (_b = (_a = this.itemCtas) === null || _a === void 0 ? void 0 : _a.map) === null || _b === void 0 ? void 0 : _b.call(_a, (cta) => {
      var _a, _b, _c;
      return (h("pes-cta-button", { key: cta, icon: "shopping-cart", text: (_c = (_b = (_a = this.ctaInfo) === null || _a === void 0 ? void 0 : _a[cta]) === null || _b === void 0 ? void 0 : _b.label) !== null && _c !== void 0 ? _c : null, importance: this.ctaInfoMapping[cta].importance, size: this.ctaInfoMapping[cta].size, onClick: this.handleUcEvent(cta) }));
    })), h("a", { href: this.productUrl, class: "alternative-item", onClick: this.linkClickHandler }, h("pes-lazy-img", { src: this.imageURL, alt: this.imageTitle, class: "alternative-item__image" }), h("div", { class: "alternative-item__body" }, h("div", { class: "alternative-item__description" }, this.description), h("div", { class: "alternative-item__name", innerHTML: this.header })))));
  }
  get el() { return getElement(this); }
};
PesAlternative.style = pesAlternativeCss;

const alternativesItemCss = ":host{display:block}.alternative__control{font-size:0.75rem;flex:0 0 auto}@media screen and (max-width: 979px){.alternative__control{order:3;box-sizing:border-box;margin:15px -15px 0;padding:10px 15px;min-height:60px;display:flex;justify-content:center;align-items:center;border-top:1px solid #e7e6e6}}@media screen and (min-width: 980px){.alternative__control{line-height:1rem}:host(:not([dir=\"rtl\"])) .alternative__control{margin:0 0 0 auto}:host([dir=\"rtl\"]) .alternative__control{margin:0 auto 0 0}}.alternative__content{display:flex;flex:0 0 100%;padding:0 15px}@media screen and (min-width: 980px){.alternative__content{flex-wrap:wrap;align-items:start;flex-direction:row}}@media screen and (max-width: 979px){.alternative__content{flex-direction:column}}.alternative-item{display:flex;text-decoration:none;flex:0 0 100%}@media screen and (max-width: 979px){.alternative-item{position:relative}}.alternative-item__image{width:50px;height:50px}@media screen and (min-width: 980px){:host(:not([dir=\"rtl\"])) .alternative-item__image:not(:first-child){margin-left:5px}:host([dir=\"rtl\"]) .alternative-item__image:not(:first-child){margin-right:5px}}:host(:not([dir=\"rtl\"])) .alternative-item__body{margin-left:15px}:host([dir=\"rtl\"]) .alternative-item__body{margin-right:15px}.alternative-item__description{font-size:0.875rem;line-height:1.25rem;color:#333333;margin:0}@media screen and (min-width: 980px){.alternative-item:active .alternative-item__description,.alternative-item:hover .alternative-item__description{text-decoration:underline}}.alternative-item__comment{margin:0 0 20px;color:#626469;font-size:0.75rem}@media screen and (max-width: 979px){.alternative-item__comment{line-height:0.9375rem}}@media screen and (min-width: 980px){.alternative-item__comment{flex:1 1 80%}}.alternative-item__name{font-size:0.625rem;line-height:1.25rem;color:#626469}";

const AlternativesItem = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.ctaClick = createEvent(this, "ctaClick", 7);
    this.handleFavoritesButtonClick = (e) => {
      this.ctaClick.emit(buildCTAClickEvent(e, {
        isCartTransferEnabled: this.isCartTransferEnabled,
        inCart: this.inCart,
        id: Object.keys(this.product)[0],
        quantity: Object.values(this.product)[0],
        onFinish: (result) => {
          if ((result === null || result === void 0 ? void 0 : result.status) === myProductsResponseStatus.SUCCESS) {
            this.inCart = !this.inCart;
            if (isAnalyticsEnabled()) {
              sendAnalytics(result, this.productId, this.product, true);
            }
          }
        },
      }));
    };
    this.linkClickHandler = (event) => {
      if (isAppRoutingEnabled()) {
        event.preventDefault();
        navigateWithRouter(this.route, event.currentTarget);
      }
    };
    this.hasCTA = undefined;
    this.inCart = undefined;
    this.addToCartLabel = undefined;
    this.removeFromCartLabel = undefined;
    this.isCartTransferEnabled = undefined;
    this.product = undefined;
    this.productId = undefined;
    this.header = undefined;
    this.imageURL = undefined;
    this.imageTitle = undefined;
    this.description = undefined;
    this.comment = undefined;
    this.url = undefined;
    this.isMobile = undefined;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  componentWillLoad() {
    this.mediaQuery = window.matchMedia('(max-width: 979px)');
    this.isMobile = this.mediaQuery.matches;
    this.mediaQuery.addEventListener('change', (e) => {
      this.isMobile = e.matches;
    });
    if (isAppRoutingEnabled()) {
      const { pageType, pageId } = parseCommonURLToRouterParts(this.url);
      this.route = new PesRoute({ page: pageType, pageId });
      this.url = this.route.url;
    }
  }
  render() {
    return (h("div", { class: "alternative__content" }, this.comment && h("p", { class: "alternative-item__comment" }, this.comment), this.hasCTA && (h("div", { class: "alternative__control" }, h("pes-favorites-button", { addIcon: this.isCartTransferEnabled ? "shopping-cart" : "star", removeIcon: this.isCartTransferEnabled
        ? "shopping-cart"
        : "star-on", addLabel: this.addToCartLabel, removeLabel: this.removeFromCartLabel, isInList: this.inCart, onClick: this.handleFavoritesButtonClick }))), h("a", { href: this.url, class: "alternative-item", onClick: this.linkClickHandler }, h("pes-lazy-img", { src: this.imageURL, alt: this.imageTitle, class: "alternative-item__image" }), h("div", { class: "alternative-item__body" }, h("div", { class: "alternative-item__description" }, this.description), h("div", { class: "alternative-item__name", innerHTML: this.header })))));
  }
  get el() { return getElement(this); }
};
AlternativesItem.style = alternativesItemCss;

const pesRuntimeBaseCellCss = ":host{display:block}::slotted([slot=error]){margin-top:6px;color:#b10043}.runtime-base-cell__value{line-height:30px}";

const RuntimeBaseCell$1 = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    return (h(Host, null, h("div", { class: "runtime-base-cell__value" }, h("slot", { name: "value" })), h("div", { class: "runtime-base-cell__error" }, h("slot", { name: "error" }))));
  }
  get el() { return getElement(this); }
};
RuntimeBaseCell$1.style = pesRuntimeBaseCellCss;

const pesRuntimeFieldCss = ":host{display:block;font-size:0.875rem;line-height:1.25rem;color:inherit}@media screen and (max-width: 979px){:host{padding-top:6px}}.runtime-field__row{display:flex;align-items:center}.runtime-field__row+.runtime-field__row{margin-top:6px}.runtime-field__label{color:inherit}:host(:not([dir=\"rtl\"])) .runtime-field__label{margin-right:8px}:host([dir=\"rtl\"]) .runtime-field__label{margin-left:8px}.runtime-field__input{box-sizing:border-box;color:#333333;font-size:1rem;line-height:inherit;height:30px;width:58px;padding:0 8px;font-weight:normal;border:1px solid #cbcbcb;outline:none}.runtime-field__input *,.runtime-field__input *::before,.runtime-field__input *::after{box-sizing:inherit}.runtime-field__input:focus,.runtime-field__input:active{border-color:#333333}.runtime-field__input--error{border-color:#b10043}.runtime-field__measure{color:#333333;font-weight:normal}:host(:not([dir=\"rtl\"])) .runtime-field__measure{margin-left:4px}:host([dir=\"rtl\"]) .runtime-field__measure{margin-right:4px}.runtime-field__load-range{display:flex;align-items:center;font-weight:normal;color:#9fa0a4}@media screen and (max-width: 979px){.runtime-field__load-range{padding-top:2px}}";

const RuntimeField = class {
  handleValueChange(value) {
    this.pesRuntimeDidInput.emit(value);
  }
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.pesRuntimeDidSubmit = createEvent(this, "pesRuntimeDidSubmit", 7);
    this.pesRuntimeDidInput = createEvent(this, "pesRuntimeDidInput", 7);
    this.inputRef = null;
    this.selectValue = '';
    this.getSelectValue = ({ target }) => {
      this.selectValue = target.value;
    };
    this.handleInput = (event) => {
      const target = event.target;
      let { value } = target;
      if (NO_LETTERS_AND_LEADING_ZERO_REGEXP.test(value)) {
        value = this.selectValue + value.replace(NO_LETTERS_AND_LEADING_ZERO_REGEXP, '');
      }
      this.selectValue = '';
      this.setValue(value);
    };
    this.handleChange = (event) => {
      const { value } = event.target;
      this.pesRuntimeDidSubmit.emit(value);
    };
    this.labels = undefined;
    this.isError = false;
    this.defaultValue = '';
    this.hideMinMaxRange = false;
    this.min = undefined;
    this.max = undefined;
    this.value = '';
    this.el.dir = document.documentElement.dir || 'auto';
  }
  componentDidLoad() {
    var _a;
    (_a = this.inputRef) === null || _a === void 0 ? void 0 : _a.addEventListener('select', this.getSelectValue);
    this.setValue(this.defaultValue);
  }
  setValue(value) {
    this.inputRef.value = value;
    this.value = value;
  }
  getLoadRangeText() {
    var _a, _b;
    return `${(_a = this.labels) === null || _a === void 0 ? void 0 : _a.minMax} ${getMinValue(this.max, this.min)}-${this.max} ${(_b = this.labels) === null || _b === void 0 ? void 0 : _b.watts}`;
  }
  render() {
    var _a, _b, _c, _d;
    return (h("div", { class: "runtime-field" }, h("pes-runtime-heading-cell", { class: "runtime-field__row", tooltipText: (_a = this.labels) === null || _a === void 0 ? void 0 : _a.enterTotalLoad }, h("div", { class: "runtime-field__label" }, (_b = this.labels) === null || _b === void 0 ? void 0 : _b.runTime), h("input", { class: {
        'runtime-field__input': true,
        'runtime-field__input--error': this.isError,
      }, type: "text", maxLength: RUNTIME_FIELD_MAX_LENGTH, ref: (el) => {
        this.inputRef = el;
      }, onTouchStart: this.getSelectValue, onInput: this.handleInput, onChange: this.handleChange }), ((_c = this.labels) === null || _c === void 0 ? void 0 : _c.watts) && h("span", { class: "runtime-field__measure" }, (_d = this.labels) === null || _d === void 0 ? void 0 : _d.watts)), !this.hideMinMaxRange && (h("div", { class: "runtime-field__row" }, h("div", { class: "runtime-field__load-range" }, h("span", { class: "runtime-field__load-range-text" }, this.getLoadRangeText()))))));
  }
  get el() { return getElement(this); }
  static get watchers() { return {
    "value": ["handleValueChange"]
  }; }
};
RuntimeField.style = pesRuntimeFieldCss;

const pesRuntimeHeadingCellCss = ":host{display:block;font-size:0.875rem;line-height:1.25rem;font-weight:bold;color:inherit}.runtime-heading{display:flex;align-items:center}.runtime-heading__label{color:inherit;display:flex;align-items:center}.runtime-heading__tooltip{color:#333333;font-weight:normal;width:16px;height:16px}:host(:not([dir=\"rtl\"])) .runtime-heading__tooltip{margin-left:4px}:host([dir=\"rtl\"]) .runtime-heading__tooltip{margin-right:4px}";

const RuntimeBaseCell = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.tooltipText = undefined;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    return (h("div", { class: "runtime-heading" }, h("div", { class: "runtime-heading__label" }, h("slot", null)), this.tooltipText && (h("pdp-icon-tooltip", { class: "runtime-heading__tooltip", icon: "information_stroke", iconSize: "micro", iconColor: "grey", position: "top" }, this.tooltipText))));
  }
  get el() { return getElement(this); }
};
RuntimeBaseCell.style = pesRuntimeHeadingCellCss;

const pesRuntimeLoadCellCss = ":host{display:block;font-size:0.875rem;line-height:1.25rem;color:#333333}@media screen and (max-width: 979px){:host{padding-top:14px;padding-bottom:8px}}";

const RuntimeLoadCell = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.value = '';
    this.labels = undefined;
    this.runtimeParams = undefined;
    this.default = false;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  getErrorMessage(errorCode) {
    var _a;
    const labelCode = RUNTIME_ERROR_CODES_TO_LABELS.LOAD[errorCode];
    const message = (_a = this.labels) === null || _a === void 0 ? void 0 : _a[labelCode];
    return formatMessage(message, labelCode, this.runtimeParams);
  }
  render() {
    if (this.default) {
      return h("div", null);
    }
    const errorMessage = this.getErrorMessage(validate(this.runtimeParams, this.value));
    const value = errorMessage ? null : calculateRuntime(this.runtimeParams, this.value);
    return (h("pes-runtime-base-cell", null, h("div", { slot: "value" }, stringifyRuntime(value, this.labels)), errorMessage && h("div", { slot: "error" }, errorMessage)));
  }
  get el() { return getElement(this); }
};
RuntimeLoadCell.style = pesRuntimeLoadCellCss;

const delimiterCss = ":host{display:block}.delimiter{padding:16px 0;text-align:center;text-transform:uppercase;font-size:0.75rem;line-height:1rem;color:#626469}";

const SubstitutionsDelimiter = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.label = undefined;
  }
  render() {
    return h("div", { class: "delimiter" }, this.label);
  }
};
SubstitutionsDelimiter.style = delimiterCss;

export { PesAlternative as pes_alternative, AlternativesItem as pes_alternatives_item, RuntimeBaseCell$1 as pes_runtime_base_cell, RuntimeField as pes_runtime_field, RuntimeBaseCell as pes_runtime_heading_cell, RuntimeLoadCell as pes_runtime_load_cell, SubstitutionsDelimiter as pes_substitutions_delimiter };
